// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Oyd_w","actions":"GroupTable_actions__27-Fp","deleteModalFooter":"GroupTable_deleteModalFooter__3cLCZ"};